import type { JSX, ReactNode } from "react";
import "./shared.scss";

export interface TabSectionHeaderProps {
  title: string;
  action?: ReactNode;
}

export function TabSectionHeader({ title, action = null }: TabSectionHeaderProps): JSX.Element {
  return (
    <div className="tab-section-header">
      <h2 className="tab-section-header__title">{title}</h2>
      <div className="tab-section-header__action">{action}</div>
    </div>
  );
}
